import { render, staticRenderFns } from "./CardPlan.vue?vue&type=template&id=94e96bcc&scoped=true"
import script from "./CardPlan.vue?vue&type=script&lang=js"
export * from "./CardPlan.vue?vue&type=script&lang=js"
import style0 from "./CardPlan.vue?vue&type=style&index=0&id=94e96bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e96bcc",
  null
  
)

export default component.exports